import { useContext, useEffect, useState } from "react";
import CancelButton from "../../assets/images/CancelButton.svg";
import SearchIcons from "../../assets/images/SearchIcons.svg";
import OpenSectionButton from "../../assets/images/OpenSectionButton.svg";
import { HelpHubFaqTypes, QuestCriteriaWithStatusType } from "./CustomHelpHub.type";
import QuestContext from "../QuestWrapper";
import { extractGradientColors, useGeneral } from "../../general";


const CustomHelpHubTasks = (props: HelpHubFaqTypes) => {

  const { faqData, contentConfig, styleConfig, setHelpHub, isActive, BrandTheme, QuestThemeData, onClose } = props;
  const [faqIndex, setFaqIndex] = useState<number | undefined>(undefined);
  const [filterData, setFilterData] = useState<QuestCriteriaWithStatusType[]>(
    []
  );
  const [searchData, setSearchData] = useState<string | number>("");
  const { themeConfig, user } = useContext(QuestContext.Context);
  const general = useGeneral('quest')

  useEffect(() => {
    let data = faqData.filter((value: QuestCriteriaWithStatusType) => {
      return value?.question
        ?.toLowerCase()
        .includes(searchData?.toString().toLowerCase());
    });
    setFilterData(data);
  }, [faqData, searchData]);

  useEffect(() => {
    if (props?.isOffline) return;
    general.trackEvent(
      "quest-helphub-faq-loaded",
      (props.uniqueUserId || props.userId || user.userId)!,
      {},
      true,
      !props.uniqueUserId,
      true
    );
  }, []);

  const cleanTiptapHTML = (html = "") => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    doc.querySelectorAll('[data-node-view-wrapper]').forEach((el) => {
      el.replaceWith(...el.childNodes);
    });

    doc.querySelectorAll('[data-drag-handle]').forEach((el) => el.remove());

    doc.querySelectorAll('[draggable]').forEach((el) =>
      el.removeAttribute('draggable')
    );

    return doc.body.innerHTML;
  };

  return (
    <div
      className={"custom-helpHubHelpCont animatedDissolve"}
    >
      <div className="q-custom-helphub-help-upper-cont">
        <div className="q-custom-helphub-help-upper-cont-text">
          <div>
            <div
              className="q-custom-helphub-help-upper-cont-text-head"
            >
              Help Center
            </div>
            <div
              className="q-custom-helphub-help-upper-cont-text-para"
            >
              Find answers and tips for getting the most out of Freedom World.
            </div>
          </div>
          <div className="q-custom-helphub-help-upper-cont-text-button">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" onClick={() => { setHelpHub(false); isActive && isActive(false); onClose && onClose(false) }}>
              <path d="M4.50586 11.4965L8.00119 8.00119L11.4965 11.4965M11.4965 4.50586L8.00053 8.00119L4.50586 4.50586" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
        </div>
      </div>

      <div className="q-custom-helphub-help-lower-cont">
        <div className="q-custom-helphub-help-lower-cont-data">
          {/* search box  */}
          <div
            className="q-custom-helphub-help-search-cont"
          >
            <input
              className="q-helphub-search-input"
              type="text"
              placeholder="Search for faq..."
              onChange={(e) => setSearchData(e.target.value)}
            />
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <g clip-path="url(#clip0_3321_76955)">
                <circle cx="7.66732" cy="7.66732" r="6.33333" stroke="#9CA3AF" stroke-width="0.917045" />
                <path d="M13.332 13.332L14.6654 14.6654" stroke="#9CA3AF" stroke-width="0.917045" stroke-linecap="round" />
              </g>
              <defs>
                <clipPath id="clip0_3321_76955">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>

          {/* for faqs  */}
          <div className="q-helphub-help-faqs-cont">
            <div className="q-custom-helphub-help-total-faqs">
              <div>
                {filterData?.length} FAQs
              </div>
            </div>

            <div className="q-helphub-help-total-faqs-cont">
              {filterData?.map(
                (value: QuestCriteriaWithStatusType, index: number) => {
                  return (
                    value.type === "VIEW_ONLY_TEXT" && (
                      <div
                        className="q-custom-helphub-help-single-faq"
                        key={index}
                      >
                        <div
                          className="text"
                          onClick={() => {
                            index === faqIndex
                              ? setFaqIndex(undefined)
                              : setFaqIndex(index);
                          }}
                        >
                          <div
                            className="head"
                          >
                            {value?.question}
                          </div>
                          <div className="but" style={{ transform: `rotate(${faqIndex === index ? 180 : 0}deg)` }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M13.0456 5.67461C13.2253 5.88428 13.2011 6.19993 12.9914 6.37964L8.32474 10.3796C8.13749 10.5401 7.86119 10.5401 7.67394 10.3796L3.00728 6.37964C2.79762 6.19993 2.77333 5.88428 2.95305 5.67461C3.13276 5.46495 3.44841 5.44067 3.65807 5.62038L7.99934 9.34147L12.3406 5.62038C12.5503 5.44067 12.8659 5.46495 13.0456 5.67461Z" fill="#6B7280" stroke="#6B7280" stroke-width="0.6" stroke-linecap="round" />
                            </svg>
                          </div>
                        </div>

                        <div
                          className={`${faqIndex === index ? "ansOpen" : "ansClose"
                            }`}
                          dangerouslySetInnerHTML={{ __html: cleanTiptapHTML(value?.answer) }}
                        />
                      </div>
                    )
                  );
                }
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomHelpHubTasks;
